<template>
  <div class="bc-report-analysis">
    <report-textarea
      :loading="loading"
      :content="content"
      :placeholder="placeholder"
      :title="title"
      @save="saveContent"
    >
      <div v-if="type === 'risk' && kind === 'analysis'">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo no-select"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="1">
            企业风险分析
          </el-menu-item>
          <el-menu-item index="2">
            行业高发风险分析
          </el-menu-item>
        </el-menu>
        <company-risk-chart v-if="activeIndex==='1'" />
        <trade-risk-chart v-if="activeIndex==='2'" />
      </div>
    </report-textarea>
  </div>
</template>

<script>
import ReportTextarea from './ReportTextarea'
import lawExamService from '@/service/law-exam'
import {
  analysisTypes
} from '@/service/law-exam/props'
import CompanyRiskChart from './CompanyRiskChart'
import TradeRiskChart from './TradeRiskChart'

export default {
  name: 'BcReportAnalysis',
  components: {
    ReportTextarea,
    CompanyRiskChart,
    TradeRiskChart
  },
  props: {
    type: {
      type: String,
      default: 'governance'
    },
    kind: {
      type: String,
      default: 'analysis'
    },
    lawSuitCount: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      content: '',
      loading: false,
      activeIndex: '1'
    }
  },
  computed: {
    companyId () {
      return this.$route.query.id
    },
    title () {
      return this.kind === 'analysis' ? '风险分析' : '风险防控建议'
    },
    placeholder () {
      return this.kind === 'analysis' ? '请输入分析……' : '请输入建议……'
    },
    queryParams () {
      let type = analysisTypes[this.type]
      let kind = this.kind === 'analysis' ? 1 : 2
      return {
        type: type,
        kind: kind,
        companyId: this.companyId
      }
    }
  },
  created () {
    // console.log(this.lawSuitCount)
    // if (this.lawSuitCount.total) {
    //   this.activeIndex = '1'
    // } else {
    //   this.activeIndex = '2'
    // }
    this.initActiveIndex()
  },
  mounted () {
    this.fetchAnalysis()
  },
  methods: {
    initActiveIndex () {},
    handleSelect (key, keyPath) {
      this.activeIndex = key
    },
    fetchAnalysis () {
      this.loading = true
      let params = {
        ...this.queryParams
      }
      lawExamService.fetchAnalysis(params).then(res => {
        this.loading = false
        this.content = res.data
      }).catch(_ => {
        this.loading = false
      })
    },
    saveContent (content) {
      let data = {}
      data[this.kind] = content
      let params = {
        ...this.queryParams,
        data
      }
      this.loading = true
      lawExamService.updateAnalysis(params).then(res => {
        this.content = content
        this.loading = false
      }).catch(_ => {
        this.loading = false
      })
    }
  }
}
// type 1：公司治理，2：公司经营，3：劳动人事，4：知识产权， 100：涉诉风险
// kind 1、分析 2、建议
</script>
